import { useEffect } from 'react';

import { toTableData } from 'common/helpers/admin-page-func.helper';
import { CatalogsApi } from './api';
import { ActionCreators, Provider, useAdminDispatch, useAdminState } from './Context';
import { Catalog } from 'common/types/catalog.type';
import { AdminLayout } from 'components/layouts';
import { useAdminParams } from 'common/hooks';
import Table from './Table';
import FormDialog from './FormDialog';
import DeleteDialog from './DeleteDialog';

let previousTableData:
    | null
    | (ReturnType<typeof toTableData<Catalog>> & {
        shouldRefetch?: boolean;
    }) = null;

const CatalogsWrapper: React.FC = () => {
    useEffect(() => {
        return function cleanUp() {
            if (previousTableData) {
                previousTableData.shouldRefetch = true;
            }
        };
    }, []);

    return (
        <AdminLayout>
            <Provider>
                <Catalogs />
            </Provider>
        </AdminLayout>
    );
};

const Catalogs = () => {
    const dispatch = useAdminDispatch();
    const { params: paramsState } = useAdminState();
    const params = useAdminParams(paramsState.filter, paramsState.sort);

    useEffect(() => {
        if (previousTableData) {
            dispatch(ActionCreators.loaded(previousTableData));
        }

        if (!params) return;

        if (!previousTableData) {
            dispatch(ActionCreators.loading());
        }

        CatalogsApi.get({ ...params, refetch: previousTableData?.shouldRefetch }).then((response) => {
            const tableData = toTableData(response);
            previousTableData = tableData;
            previousTableData.shouldRefetch = false;
            dispatch(ActionCreators.loaded(tableData));
        });
    }, [params, dispatch]);

    return (
        <>
            <Table />
            <FormDialog />
            <DeleteDialog />
        </>
    );
};

export default CatalogsWrapper;
